import axiosClient from '../../../axiosClient'
import axiosPublicClient from '../../../axiosPublicClient'

export default async ({
    backgroundRequestId,
    file,
    fileName,
    fileExtension,
    description,
    typeOfReport,
    typeOfDocument,
    obtainedFrom,
    obtainedFromDescription,
}) => {
    // Step 1: Get the pre-signed S3 upload URL
    const uploadUrlResponse = await axiosClient.post(`/document-upload-url`, {
        backgroundRequestId,
        fileName,
        fileExtension,
    })

    if (!uploadUrlResponse?.data?.url || !uploadUrlResponse?.data?.key) {
        throw new Error("Upload URL or key missing from response")
    }

    const { url, key, fileName: fileNameResponse } = uploadUrlResponse.data

    // Step 2: Upload the file to the S3 pre-signed URL
    await axiosPublicClient.put(url, file, {
        headers: {
            "Content-Type": file.type,
        },
    })

    // Step 3: Notify the backend with uploaded file key and meta info
    const saveResponse = await axiosClient.post(`/append-additional-document-v2`, {
        backgroundRequestId,
        key,
        description,
        fileName: fileNameResponse,
        fileExtension,
        typeOfReport,
        typeOfDocument,
        obtainedFrom,
        obtainedFromDescription,
    })

    return saveResponse.data
}
